export default [
    {
    "County": "Dekalb",
    "Date Of Sale": "6/10/2022",
    "Deedbook": 13007,
    "DeedPage": 373,
    "Property Address": "670 Dekalb Ave",
    "Property Value": 310000,
    "Buyer Name": "Dave smith",
    "Buyer Address": "123 Carry Lane",
    "Seller Name": "Angela Davis",
    "Seller Address": "456 Green Court"
  }, 
  {
    "County": "Dekalb",
    "Date Of Sale": "6/10/2022",
    "Deedbook": 13007,
    "DeedPage": 373,
    "Property Address": "670 Dekalb Ave",
    "Property Value": 310000,
    "Buyer Name": "Dave smith",
    "Buyer Address": "123 Carry Lane",
    "Seller Name": "Angela Davis",
    "Seller Address": "456 Green Court"
  }, 
  {
    "County": "Dekalb",
    "Date Of Sale": "6/10/2022",
    "Deedbook": 13007,
    "DeedPage": 373,
    "Property Address": "670 Dekalb Ave",
    "Property Value": 310000,
    "Buyer Name": "Dave smith",
    "Buyer Address": "123 Carry Lane",
    "Seller Name": "Angela Davis",
    "Seller Address": "456 Green Court"
  }, 
  {
    "County": "Dekalb",
    "Date Of Sale": "6/10/2022",
    "Deedbook": 13007,
    "DeedPage": 373,
    "Property Address": "670 Dekalb Ave",
    "Property Value": 310000,
    "Buyer Name": "Dave smith",
    "Buyer Address": "123 Carry Lane",
    "Seller Name": "Angela Davis",
    "Seller Address": "456 Green Court"
  }, 
  {
    "County": "Dekalb",
    "Date Of Sale": "6/10/2022",
    "Deedbook": 13007,
    "DeedPage": 373,
    "Property Address": "670 Dekalb Ave",
    "Property Value": 310000,
    "Buyer Name": "Dave smith",
    "Buyer Address": "123 Carry Lane",
    "Seller Name": "Angela Davis",
    "Seller Address": "456 Green Court"
  }

]